import { render, staticRenderFns } from "./booklistDetails.vue?vue&type=template&id=4b3288b7&scoped=true&"
import script from "./booklistDetails.vue?vue&type=script&lang=js&"
export * from "./booklistDetails.vue?vue&type=script&lang=js&"
import style0 from "./booklistDetails.vue?vue&type=style&index=0&id=4b3288b7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3288b7",
  null
  
)

export default component.exports